import userEditIcon from "../../../asset/img/user-edit.svg"
import { STEPS } from "../../../constants"
import { loc } from "../../../core/utils"
import { Breadcrumb } from "../Breadcrumb"
import HeaderLanguageSelector from "../HeaderLanguageSelector/HeaderLanguageSelector"
import { useHeader } from "./useHeader"
import React from "react"
import { Col, Container, OverlayTrigger, Row, Tooltip } from "react-bootstrap"

function Header({ tunnelData }) {
  const {
    displayBreadcrumbs,
    effectiveStepId,
    currentStepNumber,
    description,
    titleReassurance,
    reassuranceInformationPage,
    reassuranceInformationPageItalic,
    reassuranceRecapPage
  } = useHeader(tunnelData)

  const renewalProduct = tunnelData?.data?.order?.renewalProduct
  const showCustomerActionPicto =
    tunnelData?.showCustomerActionPicto === true && [STEPS.CB, STEPS.SUMMARY, STEPS.NETHEOS].includes(tunnelData.step)

  return (
    <Col sm={12} className="header-container">
      <Container className="container-header">
        <header className={`header-main${renewalProduct ? " header-main--renewal" : ""}`}>
          <Row className="align-content-center">
            <Col>
              {!!renewalProduct && (
                <div className="header-main__renewal">
                  <span className="badge-renouvellement">
                    <span className="dot" aria-hidden />
                    {loc("renouvellementActive")}
                    <OverlayTrigger
                      placement="bottom"
                      flip={false}
                      overlay={
                        <Tooltip className="renewal-activated-tooltip">{loc("renouvellementActiveTooltip")}</Tooltip>
                      }
                    >
                      <i
                        className="fas fa-info-circle info-icon"
                        tabIndex={0}
                        aria-label={loc("renouvellementActiveTooltip")}
                      />
                    </OverlayTrigger>
                  </span>
                </div>
              )}
              <h1>
                <span className="title-step">{currentStepNumber}</span>
                <span className="title-name">{loc(description)}</span>
              </h1>
            </Col>
            <Col xs="auto" className="d-flex align-items-center justify-content-end">
              {showCustomerActionPicto && (
                <span className="customer-action-picto" role="img" aria-label="Action du client requise">
                  <img src={userEditIcon} alt="" />
                </span>
              )}
            </Col>
          </Row>
          <Row>
            <Breadcrumb breadcrumbItems={displayBreadcrumbs} currentStep={effectiveStepId} />
          </Row>
          {!!titleReassurance && (
            <Row className="list-steps list-unstyled">
              <Col>
                <h1>{titleReassurance}</h1>
                <p>
                  {reassuranceInformationPage}
                  <i>{reassuranceInformationPageItalic}</i>
                </p>
                <p>{reassuranceRecapPage}</p>
              </Col>
            </Row>
          )}
        </header>
      </Container>
    </Col>
  )
}

export default Header
